var _style, _g, _path, _g2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFantasyLabsLogoFullColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 208.1 41",
    style: {
      enableBackground: "new 0 0 208.1 41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00168A;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000087401451163147742300000001558357975413213104_);}\n\t.st3{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.1,16h-5.7v3h5.2v4h-5.2v7.1h-4.7V12h10.4V16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.4,27h-6.7l-1.1,3.2h-5L49.5,12h5.2l6.9,18.1h-5L55.4,27z M54.2,23.4l-2.1-6l-2.1,6H54.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.7,30.2V12h4.7l8.7,11.1V12h4.7v18.1h-4.7l-8.7-11.1v11.1H62.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.5,27h-6.7l-1.1,3.2h-5l6.9-18.1h5.2l6.9,18.1h-5L108.5,27z M107.3,23.4l-2.1-6l-2.1,6H107.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.7,16.7c-0.5-0.4-1-0.7-1.5-0.9c-0.5-0.2-1-0.3-1.5-0.3c-0.6,0-1.1,0.1-1.5,0.4 c-0.4,0.3-0.6,0.7-0.6,1.1c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.4,0.4,0.8,0.5c0.3,0.2,0.7,0.3,1.1,0.4c0.4,0.1,0.8,0.2,1.2,0.4 c1.5,0.5,2.7,1.2,3.4,2.1c0.7,0.9,1.1,2,1.1,3.4c0,0.9-0.2,1.8-0.5,2.5c-0.3,0.8-0.8,1.4-1.4,1.9c-0.6,0.5-1.3,1-2.2,1.3 c-0.9,0.3-1.9,0.4-3,0.4c-2.3,0-4.4-0.7-6.4-2l2-3.8c0.7,0.6,1.4,1.1,2.1,1.4c0.7,0.3,1.4,0.5,2,0.5c0.8,0,1.3-0.2,1.7-0.5 c0.4-0.4,0.6-0.8,0.6-1.2c0-0.3,0-0.5-0.1-0.7c-0.1-0.2-0.3-0.4-0.5-0.6c-0.2-0.2-0.5-0.3-0.9-0.5c-0.4-0.1-0.8-0.3-1.3-0.5 c-0.6-0.2-1.2-0.4-1.8-0.6c-0.6-0.2-1.1-0.5-1.6-0.9c-0.5-0.4-0.8-0.9-1.1-1.5c-0.3-0.6-0.4-1.3-0.4-2.2c0-0.9,0.1-1.7,0.4-2.4 c0.3-0.7,0.7-1.4,1.3-1.9c0.5-0.5,1.2-0.9,2-1.2c0.8-0.3,1.6-0.4,2.6-0.4c0.9,0,1.8,0.1,2.8,0.4c1,0.2,1.9,0.6,2.8,1.1 L125.7,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.8,21.5l-6.6-9.4h5.6l3.4,5l3.3-5h5.6l-6.6,9.4v8.7h-4.7V21.5z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.9823,
    y1: 13.1379,
    x2: 176.7927,
    y2: 27.3596
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#50CEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#50CEE8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165,12l-6.9,18.1h5l1.1-3.2h6.7l1.1,3.2h5L170.2,12H165z M165.5,23.4l2.1-6l2.1,6H165.5z M152,12h-4.7v18.1 h10.4v-4H152V12z M191.3,22.1c-0.3-0.4-0.7-0.7-1.2-1c-0.5-0.3-1-0.5-1.7-0.6c0.7-0.4,1.2-0.9,1.5-1.5c0.3-0.6,0.5-1.4,0.5-2.3 c0-1.5-0.4-2.7-1.3-3.5c-0.9-0.8-2.1-1.2-3.8-1.2h-7v18.1h7.6c1,0,1.8-0.1,2.6-0.3c0.8-0.2,1.4-0.6,2-1c0.5-0.4,1-1,1.3-1.7 c0.3-0.7,0.4-1.4,0.4-2.3c0-0.5-0.1-1.1-0.2-1.5C191.8,22.9,191.6,22.4,191.3,22.1z M183,15.6h0.9c1.5,0,2.2,0.6,2.2,1.8 c0,1.2-0.7,1.8-2.2,1.8H183V15.6z M186.6,26c-0.5,0.3-1.4,0.5-2.6,0.5h-1v-3.9h1c1.2,0,2,0.2,2.6,0.5c0.5,0.3,0.8,0.8,0.8,1.5 C187.3,25.3,187.1,25.7,186.6,26z M205.5,21.2c-0.7-0.9-1.8-1.5-3.4-2.1c-0.4-0.1-0.8-0.2-1.2-0.4c-0.4-0.1-0.7-0.2-1.1-0.4 c-0.3-0.2-0.6-0.3-0.8-0.5c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.5,0.2-0.8,0.6-1.1c0.4-0.3,0.9-0.4,1.5-0.4c0.5,0,1,0.1,1.5,0.3 c0.5,0.2,1,0.5,1.5,0.9l1.9-3.7c-0.9-0.5-1.8-0.8-2.8-1.1c-1-0.2-1.9-0.4-2.8-0.4c-1,0-1.8,0.1-2.6,0.4c-0.8,0.3-1.4,0.7-2,1.2 c-0.5,0.5-1,1.1-1.3,1.9c-0.3,0.7-0.4,1.5-0.4,2.4c0,0.9,0.1,1.6,0.4,2.2c0.3,0.6,0.6,1.1,1.1,1.5c0.5,0.4,1,0.7,1.6,0.9 c0.6,0.2,1.2,0.4,1.8,0.6c0.5,0.2,1,0.3,1.3,0.5c0.4,0.1,0.7,0.3,0.9,0.5c0.2,0.2,0.4,0.4,0.5,0.6c0.1,0.2,0.1,0.4,0.1,0.7 c0,0.4-0.2,0.9-0.6,1.2c-0.4,0.4-1,0.5-1.7,0.5c-0.7,0-1.4-0.2-2-0.5c-0.7-0.3-1.4-0.8-2.1-1.4l-2,3.8c2,1.4,4.1,2,6.4,2 c1.1,0,2.1-0.1,3-0.4c0.9-0.3,1.6-0.7,2.2-1.3c0.6-0.5,1.1-1.2,1.4-1.9c0.3-0.8,0.5-1.6,0.5-2.5C206.6,23.1,206.2,22,205.5,21.2z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "82.3,12 82.3,16.1 88.5,16.1 88.5,30.2 93.2,30.2 93.2,16.1 99.5,16.1 99.5,12  "
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033358991551678964760000001729503102409822637_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.4868,
    y1: 20.477,
    x2: 28.3211,
    y2: 20.477
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#50CEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#50CEE8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033358991551678964760000001729503102409822637_)"
    },
    d: "M16.3,13.7c0-0.8-0.6-1.4-1.4-1.4 c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4C15.7,15.1,16.3,14.5,16.3,13.7z M14.8,19.7c0,1.2,1,2.2,2.2,2.2 c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2C15.8,17.5,14.8,18.5,14.8,19.7z M27.7,29.5L27.7,29.5L27.7,29.5l-7.2-16.9l0-4.4 C21.4,7.6,22,6.5,22,5.3c0-2.1-1.7-3.9-3.9-3.9h-0.6H12h-0.4c-2.1,0-3.9,1.7-3.9,3.9c0,1.2,0.5,2.2,1.3,2.9l0,4.5L2.1,29.5 c-0.9,2.1-0.8,4.5,0.3,6.5c1.2,2.2,3.3,3.5,5.6,3.5h13.9c2.3,0,4.4-1.3,5.6-3.5C28.5,34.1,28.6,31.6,27.7,29.5z M15.5,23.7 c-2.6-2.7-5.4-2.4-7.2-1.7l3.7-8.8l-0.1-6.9c0,0-0.1,0-0.1,0h-0.1c-0.6,0-1-0.5-1-1v0c0-0.6,0.5-1,1-1H12h5.6h0.6c0.6,0,1,0.5,1,1 v0c0,0.6-0.5,1-1,1h-0.3c0,0-0.1,0-0.1,0l0,6.9l4.9,11.4C21.1,25.6,18.3,26.6,15.5,23.7z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M12.1,31.1c-1.9,0-3.5-1.5-3.5-3.5c0-1.9,1.5-3.5,3.5-3.5s3.5,1.5,3.5,3.5C15.5,29.5,14,31.1,12.1,31.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.5,34.6c-1.4,0-2.4-1.1-2.4-2.4c0-1.4,1.1-2.4,2.4-2.4c1.4,0,2.4,1.1,2.4,2.4 C21.9,33.6,20.8,34.6,19.5,34.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFantasyLabsLogoFullColor);
export default __webpack_public_path__ + "static/media/FantasyLabs_Logo_FullColor.69a9bf26496f1b3c6d1ecca056ce154f.svg";
export { ForwardRef as ReactComponent };